import { createElementVNode as _createElementVNode, openBlock as _openBlock, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bf4c76f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "BackButton__Icon" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 22 14" }, [
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-arrow-left" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 22 14" }, [
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-arrow-left" })
    ])
  ])
], -1))
const _hoisted_2 = { class: "BackButton__Text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.type), {
    type: _ctx.type === 'button' ? _ctx.type : false,
    to: _ctx.to,
    class: "BackButton"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("span", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ]),
    _: 3
  }, 8, ["type", "to"]))
}